// @flow
import { QuestionTypesActionTypes } from './constants';

type QuestionTypesAction = { type: string, payload: {} | string };

// common success
export const questionTypesApiResponseSuccess = (actionType: string, data: any): QuestionTypesAction => ({
    type: QuestionTypesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const questionTypesApiResponseError = (actionType: string, error: string): QuestionTypesAction => ({
    type: QuestionTypesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getQuestionType = (id: string): QuestionTypesAction => ({
    type: QuestionTypesActionTypes.GET_QUESTION_TYPE,
    payload: { id },
});

export const addQuestionType = (questionType:any):QuestionTypesAction=>({
    type:QuestionTypesActionTypes.ADD_QUESTION_TYPE,
    payload:questionType
})
export const updateQuestionType = (questionType:any):QuestionTypesAction=>({
    type:QuestionTypesActionTypes.UPDATE_QUESTION_TYPE,
    payload:questionType
})
export const deleteQuestionType = (id:string):QuestionTypesAction=>({
    type:QuestionTypesActionTypes.DELETE_QUESTION_TYPE,
    payload:{id}
})

export const listQuestionTypes = (params:any): QuestionTypesAction => ({
    type: QuestionTypesActionTypes.LIST_QUESTION_TYPES,
    payload: params,
});


export const resetQuestionTypes = (): QuestionTypesAction => ({
    type: QuestionTypesActionTypes.RESET,
    payload: {},
});

